import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { Trans, Translation } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUDateFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.clearDates = this.clearDates.bind(this);
    }

    componentDidMount() {
        var self = this;
        $('#vehicle-start-date').datepicker({
            dateFormat: 'MM d, yy',
            minDate: 0,
            onSelect: function(date) {
                self.props.onChange(date, 'start_date')
		    },
        });

        $('#vehicle-end-date').datepicker({
            dateFormat: 'MM d, yy',
            minDate: 0,
            onSelect: function(date) {
                self.props.onChange(date, 'end_date')
		    },
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    toggleDropdown(id, btn) {
        const element = document.getElementById(id);
        const button = document.getElementById(btn);
        if (!element || !button) return;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
            button.classList.remove('bkg-primary');
        } else {
            $('.dropdown-pane').removeClass('is-open');
            $('.dropdown').removeClass('bkg-primary');
            element.classList.add('is-open');
            button.classList.add('bkg-primary');
        }
    }

    clearDates(e) {
        $("#vehicle-start-date").val("");
        $("#vehicle-end-date").val("");

        this.props.clearDates();
        this.toggleDropdown('dates-dropdown','dates-dropdown-button');
    }

    render() {
        return (
            <>
                <div className = "button dropdown ml-8" id = "dates-dropdown-button" data-toggle="dates-dropdown" onClick={()=>this.toggleDropdown('dates-dropdown','dates-dropdown-button')}><Trans>Dates</Trans></div>
                <div className = "dropdown-pane filter-dropdown-pane eu-filter-dates p-16" id = "dates-dropdown" data-dropdown data-auto-focus="true" >
                    <ul className = "menu vertical">
                        <Translation>
                            {
                                (t) => <input id="vehicle-start-date" type="text" placeholder={t("Pick Up Date")} className="datepicker mb-8 date-input-field" />
                            }
                        </Translation>
                        <Translation>
                            {
                                (t) => <input id="vehicle-end-date" type="text" placeholder={t("Drop Off Date")} className="datepicker date-input-field no-margin" />
                            }
                        </Translation>
                        <a className="dropdown-pane-action" onClick={this.clearDates}><Trans>Clear</Trans></a>
                    </ul>
                </div>
            </>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(EUDateFilter);